import { version } from './env';
import * as T from './types/settings.types';
import { getTimeZoneMark } from './utils/datetime';
import { getLocation, getPlatform } from './utils/platform';

const TIMEZONE = getTimeZoneMark();
const PLATFORM = getPlatform({
  chrome: 'android',
});

const PLATFORM_MOBILE_PREFIX = 'm';

export const EVENTS: T.IEvents = {
  READY: 'ready',
  CHANGE: 'change',
  ERROR: 'error',
  SUBSCRIBE: 'subscribe',
  UNSUBSCRIBE: 'unsubscribe',
};

export const ERRORS: T.IErrors = {
  SUBSCRIBE: {
    code: 'subscribe',
    message: 'Ошибка при попытке подписаться на пуш-уведомления',
  },
  UNSUBSCRIBE: {
    code: 'unsubscribe',
    message: 'Ошибка при попытке отписаться от пуш-уведомлений',
  },
  GET_SUBSCRIPTION: {
    code: 'get_subscription',
    message: 'Ошибка при попытке получения объекта пуш-уведомлений',
  },
  PERMISSION_DENIED: {
    code: 'permission_denied',
    message: 'Пользователь запретил доставку уведомлений',
  },
  UNSUPPORTED: {
    code: 'unsupported',
    message: 'Не поддерживается браузером',
  },
  TIME_MARK: {
    code: 'time_mark',
    message: 'Установлена временная отметка',
  },
  SERVER_SYNC: {
    code: 'server_sync',
    message: 'Ошибка синхронизации с сервером',
  },
  UNKNOWN_PLATFORM: {
    code: 'unknown_platform',
    message: 'Неизвестный браузер или платформа',
  },
  CUSTOM: {
    code: 'custom',
    message: '',
  },
  FCM_API_INVALID_KEY: {
    code: 'fcm_api_invalid_key',
    message: '[FirebaseMessagingAPI]: invalid key',
  },
  FCM_API_NOT_SUBSCRIBED: {
    code: 'fcm_api_not_subscribed',
    message: '[FirebaseMessagingAPI]: not subscribed',
  },
  FCM_API_RETURNED_EMPTY_TOKEN: {
    code: 'fcm_api_returned_empty_token',
    message: '[FirebaseMessagingAPI]: returned empty token',
  },
  FCM_API_APPLICATIONNAME_NOT_FOUND: {
    code: 'fcm_api_applicationname_not_found',
    message: '[FirebaseMessagingAPI]: applicationname not found',
  },
};

export const APP_DEFAULTS: T.IAppDefaults = {
  version,
  allowedPlatforms: ['Chrome', 'Firefox'],
  application: 'mailrupush',
  platform: PLATFORM.BROWSER,
  workerPath: '/push-worker.js',
  workerScope: '/',
  workerInstaller: null,
  serverUrl: '/push-api/subscription/',
};

export const WORKER_PAYLOAD: T.IWorkerPayload = {
  location: getLocation().pathname,
  platform: PLATFORM,
  timezone: TIMEZONE,
};

export const SERVER_PAYLOAD: T.IServerPayload = {
  application: null, // константа
  platform: 'webpush', // константа
  status: null, // 0 - подписаться, -1 отписаться
  token: null, // push_token (google reg id)
  settings: {
    capabilities: {
      geo_id: [0], // рассылка пушей по гео
      push_delivery_time_range: '00:00-23:59', // время доставки пушей
    },
    client: {
      os_version: PLATFORM.BROWSER.VERSION,
      version: PLATFORM.BROWSER.IS_MOBILE
        ? `${PLATFORM_MOBILE_PREFIX}-${version}`
        : version, // версия софта на фронте
    },
    client_time_zone: TIMEZONE,
  },
};
